<template>
  <v-row class="twitter"
    align="center"
    justify="center"
  >
    <v-col class="fill-height"
      align-self="center"
    >
      <link-prevue
        :url="url"
      >
        <template slot-scope="props">
          <v-card class="mx-auto link-prevue-card"
            max-width="400"
          >
            <v-img class="card-img-top"
              :src="props.img"
              :alt="props.title"
            />
            <div class="card-block">
              <v-card-title>{{ props.title }}</v-card-title>
              <v-card-text>{{ props.description }}</v-card-text>
              <v-card-actions class="align-end">
                <v-spacer></v-spacer>
                <v-btn rounded x-large
                  :href="props.url"
                >
                  More
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </div>
          </v-card>
        </template>
      </link-prevue>
    </v-col>
    <v-col align-self="center">
      <Timeline class="timeline"
        :style="timeline_style"
        :id="user_id"
        :source-type="source_type"
        :options="options"
      />
    </v-col>
  </v-row>
</template>

<script>
import { Timeline } from 'vue-tweet-embed'
import LinkPrevue from 'link-prevue'

export default {
  components: {
    Timeline,
    LinkPrevue,
  },
  data: function() {
    var contents_width = window.innerWidth - 12 * 2;
    return {
      url: 'https://twitter.com/KnothSug',
      user_id: 'KnothSug',
      source_type: 'profile',
      options: {
        theme: 'dark',
        width: contents_width < '500' ? contents_width : '500',
        height: window.innerHeight - (this.$vuetify.application.top * 2 + 12 * 4) // 1vh - header - padding
      },
      timeline_style: contents_width < '500' ? 'width: '+ contents_width +'px;' : 'width: 500px;',
   };
  }
}

</script>